import PageHero from '../../components/PageHero';
import { Link } from 'react-router-dom';
import './StaticPage.css';

function PartnersPage() {
  return (
    <div className="static-page content-page">
      <PageHero
        title="Partners"
        subtitle="Collaborate with WeddingzVenue"
      />
      <div className="content-container">
        <p>
          We work with event planners, wedding portals, and brands to offer couples a seamless planning
          experience. If you&apos;re interested in a partnership—content, integrations, or co-marketing—we&apos;d
          love to hear from you.
        </p>
        <h2>Partnership opportunities</h2>
        <ul>
          <li>Content and editorial collaborations</li>
          <li>API or integration partnerships</li>
          <li>Referral and affiliate programmes</li>
          <li>Co-branded campaigns and events</li>
        </ul>
        <h2>Contact</h2>
        <p>
          Reach out to our partnerships team at{' '}
          <a href="mailto:contact@weddingzvenue.in">contact@weddingzvenue.in</a> with the subject
          &quot;Partnership&quot; or via our <Link to="/contact">Contact</Link> page.
        </p>
      </div>
    </div>
  );
}

export default PartnersPage;
